module.exports = __webpack_public_path__ + "img/password.c121133d.svg";